module.exports = __webpack_public_path__ + "static/img-3-mobile-65ee5c3e63c61564f6786f95609fbe69.jpg";